import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-track-appointment',
  templateUrl: './track-appointment.component.html',
  styleUrls: ['./track-appointment.component.scss']
})
export class TrackAppointmentComponent implements OnInit {
  showloading: boolean = true;
  notfound: boolean = false;
  bookingId: string = "";
  isLoading = false;
  bookingDetails: any;
  showComponent: boolean = false;
  errorMessage: string = "";

  accessToken:any;

  constructor(private router: Router, private apiService: ApiService, private storage: StorageService,  private spinner: NgxSpinnerService) { }

  getBookingUserDetails() {
    this.errorMessage = "";
    this.showComponent = false;
    this.isLoading = true;
    if (this.bookingId !== "") {
      this.isLoading = true;
      // this.spinner.show();
      this.apiService.getBookingDetails(this.bookingId).subscribe({
        next: (response: any) => {
          if (response.status === "success") {
            this.showComponent = true;
            this.isLoading = false;
            // this.spinner.hide();
            this.errorMessage = "";
            this.bookingDetails = response;

            this.router.navigate(['track-appointment/booking-list']);


            // Storing token and user id
            // this.storage.set('token', this.bookingDetails.token);
            this.storage.set('km_participant_id', this.bookingDetails.user_id);
            this.storage.set('med_participant_booking_details', JSON.stringify(this.bookingDetails));

            this.router.navigate(['/track-appointment/booking-list']);
          }
        },
        error: (err: any) => {
          this.isLoading = false;
          // this.spinner.hide();
          this.showComponent = false;
          this.errorMessage = err.error.message;
          setTimeout(() => {
            this.errorMessage = "";
          }, 6000);
        },
        complete: () => { }
      });
    } else {
      this.isLoading = false;
      // this.spinner.hide();
    }

  }

  ngOnInit(): void {

    this.accessToken = this.storage.get('token');
  }
}
